export enum Strings {
  ASTERISK = '*',
  EMPTY_STRING = '',
  DASH = '-',
  WHITE_SPACE = ' ',
  SLASH = '/',
}
